import Checkbox from './Checkbox/Checkbox';
import NumberToggle from './NumberToggle/NumberToggle';
import PasswordStrengthIndicator from './PasswordStrengthIndicator/PasswordStrengthIndicator';
import Radios from './Radios/Radios';
import Select from './Select/Select';
import SingleDateSelect from './SingleDateSelect/SingleDateSelect';
import Slider from './Slider/Slider';
import Spacer from './Spacer/Spacer';
import Switch from './Switch/Switch';
import TextInput from './TextInput/TextInput';
import TwoFactorAuthentication from './TwoFactorAuthentication/TwoFactorAuthentication';
import PhoneNumber from './PhoneNumber';
import MultiselectTypeAhead from './MultiselectTypeAhead';
import SwitchGroup from './SwitchGroup/SwitchGroup';

const FormElements = {
  Checkbox,
  NumberToggle,
  PasswordStrengthIndicator,
  Radios,
  Select,
  SingleDateSelect,
  Slider,
  Spacer,
  Switch,
  TextInput,
  TwoFactorAuthentication,
  PhoneNumber,
  MultiselectTypeAhead,
  SwitchGroup
};

export default FormElements;
